import { render, staticRenderFns } from "./caseSizeOptions.vue?vue&type=template&id=5f9c0e82&scoped=true&"
import script from "./caseSizeOptions.vue?vue&type=script&lang=js&"
export * from "./caseSizeOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c0e82",
  null
  
)

export default component.exports